import ModalVistaPrevia from 'components/Admin/Certificados/ModalVistaPrevia'
import { UserData } from 'components/Sidebar/Sidebar_Principal'
import { alertService } from 'components/Varios/alert_service'
import Cargando from 'components/Varios/Cargando'
import ModalVistaPreviaDocumentos from 'components/Varios/Modals/ModalVistaPreviaDocumentos'
import { GetDocumentVistaPrevia } from 'helpers/files'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { authenticationService } from 'services/authentication.service'
import { HistorialSolicitudesVacacionesTH } from './TypesHistorialAprovacionesV'
import { /*ObtenerAniosHistorial,*/ ObtenerHistorial } from './FunctionsHistorialVacaciones'
import TablaHistorialVacaciones from './TablaHistorialVacaciones'
import ModalConfirmacion from 'components/Varios/Modals/ModalConfirmacion'
import { GetDateObjectFromDate, ObtenerFechaFromIsoFormat, ParseFechaToUsaFormat } from 'functions/DatesFunctions'
import { Row, Col, Table, Container, Label, Input } from "reactstrap";
import { Form, FormGroup, Button } from 'react-bootstrap'
import Datepicker from '../../Varios/Datepicker'

type StateHistorialAprobacion = {
    fechaDesde: Date | null,
    fechaHasta: Date | null,
    tipoSolicitud: string,
    estadoSolicitud: string,
    estadoAP: string,
    historial: HistorialSolicitudesVacacionesTH[],
    loading: boolean,
    error: boolean,
    anioSeleccionado: number
}

type StateModalVistaPrevia = {
    loading: boolean,
    url: string
}

type StateModalMotivoRechazo = {
    loading: boolean,
    tabladetalle: HistorialSolicitudesVacacionesTH | undefined,
}

export default function HistorialAprobacionesV() {
    const defaultStateHistorial: StateHistorialAprobacion = {
        fechaDesde: null,
        fechaHasta: null,
        tipoSolicitud: "",
        estadoSolicitud: "",
        estadoAP: "",
        historial: [],
        loading: false,
        error: false,
        anioSeleccionado: -1
    }

    const defaultStateModalVistaPrevia: StateModalVistaPrevia = {
        loading: false,
        url: ""
    }   

    const defaultStateModalMotivoRechazo: StateModalMotivoRechazo = {
        loading: false,
        tabladetalle: undefined,
    }

    const [stateHistorial, setstateHistorial] = useState<StateHistorialAprobacion>(defaultStateHistorial)
    const [stateModalVP, setstateModalVP] = useState<StateModalVistaPrevia>(defaultStateModalVistaPrevia)
    const [stateModalMotivoRechazo, setstateModalMotivoRechazo] = useState<StateModalMotivoRechazo>(defaultStateModalMotivoRechazo)

    const [fechaDesde, setfechaDesde] = useState<Date | null>(null)
    const [fechaHasta, setfechaHasta] = useState<Date | null>(null)
    const [tipoEstado, setTipoEstado] = useState<string>("")
    const [estadoSolicitud, setEstadoSolicitud] = useState<string>("")
    const [estadoAP, setEstadoAP] = useState<string>("")

    useEffect(() => {
        window.location.href = "https://th.espol.edu.ec/";
        //const fechaActual = new Date();
        //const mesActual = fechaActual.getMonth();
        //const anioActual = fechaActual.getFullYear();

        //const fechaDesde = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), 1)
        //setfechaDesde(fechaDesde)
        //setfechaHasta(fechaActual)
    }, [])

    const OnChange = useCallback((name: string, valor: any) => {

        if (name === "fechadesde") {
            setfechaDesde(valor)
            if (fechaHasta && new Date(fechaHasta).getMonth() !== new Date(valor).getMonth()) {
                setfechaHasta(null);
            }
        }
        else if (name === "fechahasta") {
            setfechaHasta(valor);
        }
    }, [fechaDesde, fechaHasta])

    async function ConsultarHistorial(stateHistorial: StateHistorialAprobacion) {
        if (!validarCampos()) {
            alertService.warning("Por favor complete todos los campos requeridos");
            return;
        }

        setstateHistorial(prev => ({ ...prev, loading: true }));
        try {
            const respuesta = await ObtenerHistorial(fechaDesde, fechaHasta,
                tipoEstado === "solicitud" ? estadoSolicitud : "",
                tipoEstado === "ap" ? estadoAP : ""
            );
            if (respuesta.status !== 200) {
                alertService.error("Ha ocurrido un inconveniente al obtener el historial de vacaciones/reintegro");
                setstateHistorial(prev => ({ ...prev, error: true, loading: false }));
            } else {
                setstateHistorial(prev => ({
                    ...prev,
                    historial: respuesta.dataResponse,
                    loading: false,
                    error: false
                }));
            }
        } catch (error) {
            alertService.error("Error al obtener el historial");
            setstateHistorial(prev => ({ ...prev, error: true, loading: false }));
        }
    }

    const onClickVerDoc = useCallback(
        async (referencia: string) => {
            setstateModalVP({ ...stateModalVP, loading: true })
            const datosUsuario: UserData = authenticationService.currentUserValue;
            const url = await GetDocumentVistaPrevia(referencia, datosUsuario.token);
            setstateModalVP({ ...stateModalVP, loading: false, url })
        }, [stateModalVP])    

    const VerMotivoRechazo = (solicitud: HistorialSolicitudesVacacionesTH) => {
        setstateModalMotivoRechazo({ tabladetalle: solicitud, loading: false, })
    }    

    const contenidoModalMotivoRechazo: any = useMemo(() => {
        if (stateModalMotivoRechazo.loading) {
            return <Cargando />
        }
        else if (stateModalMotivoRechazo.tabladetalle === undefined) {
            return (
                <>
                    <br />
                    <p className='text-center'>No hay detalle de permisos / licencias</p>
                </>
            )
        }
        else if (stateModalMotivoRechazo.tabladetalle !== undefined) {
            const solicitud = stateModalMotivoRechazo.tabladetalle;
            const tabla =
                <>
                    <Table bordered className="tableHistorialSolicitudesVacaciones" responsive>
                        <thead className="cabecerasDetallehistorialSolic">
                            <tr className="">
                                <th style={{ fontSize: '18px', padding: '15px', whiteSpace: 'pre-line', lineHeight: '1.6' }}> Motivo del Rechazo </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="rowHistorialSolicitudVacaciones" key={"rowDetalleHistorico " + solicitud.idSolicitudVacacion}>
                                <td className="">
                                    <div style={{ fontSize: '16px', padding: '15px', whiteSpace: 'pre-line', lineHeight: '1.6' }}>
                                        {solicitud.motivo}
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </>
            return tabla;
        }
    }, [stateModalMotivoRechazo])

    const tablaHistorial = useMemo(() => {
        if (stateHistorial.loading) {
            return <Cargando />
        }
        else if (stateHistorial.error) {
            return <div>No ha sido posible obtener información</div>
        }
        else if (!stateHistorial.error && stateHistorial.historial.length === 0) {
            return <div>No hay historial de solicitudes por mostrar</div>
        }
        else if (!stateHistorial.loading && stateHistorial.historial.length > 0) {
            return (
                <TablaHistorialVacaciones
                    dataFilas={stateHistorial.historial}
                    onClickVerDocumento={async (referencia: string) => await onClickVerDoc(referencia)}
                    onClickVerMotivo={async (solicitud: HistorialSolicitudesVacacionesTH) => await VerMotivoRechazo(solicitud)}
                    fechaDesde={fechaDesde}
                    fechaHasta={fechaHasta}
                    estadoSolicitud={estadoSolicitud}
                    estadoAP={estadoAP}
                />
            )
        }
    }, [stateHistorial.loading, stateHistorial.error, stateHistorial.historial, onClickVerDoc, fechaDesde, fechaHasta, estadoSolicitud, estadoAP])

    const handleTipoEstadoChange = (e) => {
        setTipoEstado(e.target.value);
        // Resetear estados cuando cambia el tipo
        setEstadoSolicitud("");
        setEstadoAP("");
        setstateHistorial(defaultStateHistorial);
    };

    const handleEstadoSolicitudChange = (e) => {
        setEstadoSolicitud(e.target.value);
        setstateHistorial(defaultStateHistorial);
    };

    const handleEstadoAPChange = (e) => {
        setEstadoAP(e.target.value);
        setstateHistorial(defaultStateHistorial);
    };

    const validarCampos = useCallback(() => {
        // 1. Validación de fechas (obligatorias siempre)
        if (!fechaDesde || !fechaHasta) return false;

        // 2. Si NO se seleccionó "Todos" (tipoEstado tiene valor)
        if (tipoEstado) {
            // Validar el estado correspondiente al tipo seleccionado
            if (tipoEstado === "solicitud" && !estadoSolicitud) return false;
            if (tipoEstado === "ap" && !estadoAP) return false;
        }

        // 3. Si pasó todas las validaciones o se seleccionó "Todos"
        return true;
    }, [fechaDesde, fechaHasta, tipoEstado, estadoSolicitud, estadoAP]);

    return (
        <div className="content">
            <div className="titulo_seccion mb-5"> HISTORIAL SOLICITUDES VACACIONES/PERMISO IMPUTABLE/REINTEGRO </div>

            <Form>
                <Row className="content">
                    <Col xs={12} lg={2} xl={2}>
                        <FormGroup>
                            <Label for="fechadesde">
                                Desde:
                            </Label>
                            <Datepicker
                                value={fechaDesde}
                                /*disabled={disabledGeneral}*/
                                name="fechadesde"
                                id="fechadesde"
                                onChange={(e, name) => OnChange(name, e)}
                                min={null}
                                max={null}
                                showDisabledMonthNavigation={false}
                                showYearDropdown
                                monthdropdown={true}
                                portalId={"root"}
                            />
                        </FormGroup>
                    </Col>
                    <Col xs={12} lg={2} xl={2}>
                        <FormGroup>
                            <Label for="fechahasta">
                                Hasta:
                            </Label>
                            {
                                fechaDesde === null &&
                                <Datepicker
                                    disabled={true}
                                />
                            }
                            {
                                fechaDesde &&
                                <Datepicker
                                    value={fechaHasta}
                                    disabled={fechaDesde === null}
                                    name="fechahasta"
                                    id="fechahasta"
                                    onChange={(e, name) => OnChange(name, e)}
                                    min={fechaDesde}
                                    max={null}
                                    showDisabledMonthNavigation={false}
                                    showYearDropdown
                                    monthdropdown={true}
                                    portalId={"root"}
                                />
                            }

                        </FormGroup>
                    </Col>
                    <Col md={3} className="pr-0">
                        <FormGroup>
                            <Label for="tipoEstado" className="label-permiso">
                                Estado a consultar {!tipoEstado && <span className="text-danger">*</span>}
                            </Label>
                            <Input type="select" value={tipoEstado} onChange={handleTipoEstadoChange} id="tipoEstado">
                                <option value="">Todos</option>
                                <option value="solicitud">Permisos Imputables y Solicitudes de Vacaciones</option>
                                <option value="ap">Acción de Personal</option>
                            </Input>
                        </FormGroup>
                    </Col>
                    {tipoEstado === "solicitud" && (
                        <>
                            <Col md={2} className="pr-0">
                                <FormGroup>
                                    <Label for="estadoSolicitud" className="label-permiso">Estado Solicitud</Label>
                                    <Input type="select" value={estadoSolicitud} onChange={handleEstadoSolicitudChange} id="tipoEstado">
                                        <option value=""></option>
                                        <option value="todos">TODOS</option>
                                        <option value="1, P">Ingresado</option>
                                        <option value="2, E">Aprobado por Directivo de Unidad</option>
                                        <option value="3, A">Validado por Talento Humano</option>
                                        <option value="5, I">Rechazado por Talento Humano</option>
                                    </Input>
                                </FormGroup>
                            </Col>
                        </>
                    )}
                    {tipoEstado === "ap" && (
                        <>
                            <Col md={2} className="pr-0">
                                <FormGroup>
                                    <Label for="estadoSolicitud" className="label-permiso">Estado Acción de Personal</Label>
                                    <Input type="select" value={estadoAP} onChange={handleEstadoAPChange} id="tipoEstado">
                                        <option value=""></option>
                                        <option value="todos">Todos</option>
                                        <option value="0">Para elaboración</option>
                                        <option value="1">Para revisión</option>
                                        <option value="2">Para firma delegado TH</option>
                                        <option value="3">Para firma M. Autoridad</option>
                                        <option value="4">Para Revisión y Control</option>
                                        <option value="5">Para Notificación</option>
                                        <option value="6">NOTIFICADO</option>
                                        <option value="I">ANULADA</option>
                                    </Input>
                                </FormGroup>
                            </Col>
                        </>
                    )}
                    <Col xs={12} md={2} className="d-flex align-items-center">
                        {
                            fechaDesde && fechaHasta &&
                            <Button
                                onClick={() => ConsultarHistorial(stateHistorial)}
                                disabled={!validarCampos() || stateHistorial.loading}
                                className="w-100" // Para que ocupe todo el ancho de la columna
                            >
                                {stateHistorial.loading ? "Cargando..." : "Generar Historial"}
                            </Button>
                        }
                        {
                            (fechaDesde === null || fechaHasta === null) &&
                            <Button disabled className="w-100">Generar Historial</Button>
                        }
                    </Col>
                </Row>
            </Form>

            {tablaHistorial}

            <ModalVistaPreviaDocumentos
                cargandoDatos={stateModalVP.loading}
                onClose={() => setstateModalVP(defaultStateModalVistaPrevia)}
                show={stateModalVP.loading || stateModalVP.url !== ""}
                size="xl"
                tituloModal='Documento solicitud'
                urlArchivo={stateModalVP.url}
                botonCerrar={true}
            />            

            <ModalConfirmacion
                show={stateModalMotivoRechazo.tabladetalle !== undefined}
                asyncAccion={false}
                asyncClose={false}
                closeAfterAccion={false}
                hideBotonCerrar={false}
                mensajeConfirmacion={""}
                nombreBotonAccion={"Cerrar"}
                onClose={() => setstateModalMotivoRechazo({ tabladetalle: undefined, loading: false, })}
                size={"xl"}
                contentModal={contenidoModalMotivoRechazo}
                tituloModal={"Motivo del rechazo de la solicitud"}
                classNameAllModal={""}
            />
        </div>
    )
}